// src/LandingPage.js
import React from 'react';

function LandingPage() {
  return (
    <section className="landing-hero">
      <h2>Willkommen bei GeHa-Projects-Boards</h2>
      <p>
        Verwalte deine Projekte übersichtlich in Kanban-Boards, teile Aufgaben mit deinem Team
        und behalte den Fortschritt stets im Blick.
      </p>
      <ul className="landing-features">
        <li>Einfache Bedienung</li>
        <li>Echtzeit-Zusammenarbeit</li>
        <li>Flexibles Status-Management</li>
      </ul>
    </section>
  );
}

export default LandingPage;
